import { useState } from "react";
import {
  signInWithPopup,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
} from "firebase/auth";
import { auth, googleProvider } from "./firebase";

// ─── Mochi pixel logo ─────────────────────────────────────────────────────────

function MochiLogo({ size = 4 }) {
  const _ = null;
  const W = "#f5e6ff", P = "#c084fc", D = "#7c3aed";
  const L = "#e9d5ff", K = "#1a0a2e", R = "#f9a8d4";
  const H = "#4c1d95", G = "#a78bfa";

  const grid = [
    [_,_,_,_,_,_,_,H,H,H,H,H,H,H,H,H,H,_,_,_,_,_,_,_],
    [_,_,_,_,_,_,H,H,_,_,_,_,_,_,_,_,H,H,_,_,_,_,_,_],
    [_,_,_,P,P,_,H,H,_,_,_,_,_,_,_,_,H,H,_,P,P,_,_,_],
    [_,_,P,P,P,P,H,H,_,_,_,_,_,_,_,_,H,H,P,P,P,P,_,_],
    [_,_,P,R,P,P,_,_,_,_,_,_,_,_,_,_,_,_,P,P,R,P,_,_],
    [_,_,P,P,P,_,_,_,_,_,_,_,_,_,_,_,_,_,_,P,P,P,_,_],
    [_,D,D,D,D,D,D,D,D,D,D,D,D,D,D,D,D,D,D,D,D,D,D,_],
    [D,W,W,W,W,W,W,W,W,W,W,W,W,W,W,W,W,W,W,W,W,W,W,D],
    [D,W,W,W,W,W,W,W,W,W,W,W,W,W,W,W,W,W,W,W,W,W,W,D],
    [D,W,W,L,W,W,W,W,W,W,W,W,W,W,W,W,W,W,W,W,L,W,W,D],
    [D,W,W,W,W,K,K,W,W,W,W,W,W,W,W,W,W,K,K,W,W,W,W,D],
    [D,W,W,W,W,K,K,W,W,W,W,W,W,W,W,W,W,K,K,W,W,W,W,D],
    [D,W,W,W,W,W,W,W,W,W,W,W,W,W,W,W,W,W,W,W,W,W,W,D],
    [D,W,W,W,W,W,W,W,W,W,R,W,W,R,W,W,W,W,W,W,W,W,W,D],
    [D,W,W,W,W,W,W,W,W,W,W,R,R,W,W,W,W,W,W,W,W,W,W,D],
    [D,W,W,W,R,W,W,W,W,W,W,W,W,W,W,W,W,W,W,R,W,W,W,D],
    [D,W,W,W,W,W,W,W,W,W,W,W,W,W,W,W,W,W,W,W,W,W,W,D],
    [D,W,W,W,W,W,W,W,W,W,W,W,W,W,W,W,W,W,W,W,W,W,W,D],
    [D,W,W,W,W,W,W,W,W,W,W,W,W,W,W,W,W,W,W,W,W,W,W,D],
    [D,W,G,G,W,W,W,W,W,W,W,W,W,W,W,W,W,W,W,W,G,G,W,D],
    [_,D,G,G,G,W,W,W,W,W,W,W,W,W,W,W,W,W,W,G,G,G,D,_],
    [_,_,D,D,G,G,W,W,W,W,W,W,W,W,W,W,W,W,G,G,D,D,_,_],
    [_,_,_,_,D,D,D,D,D,D,D,D,D,D,D,D,D,D,D,D,_,_,_,_],
    [_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_],
  ];

  return (
    <div style={{ display:"grid", gridTemplateColumns:`repeat(24,${size}px)`, gridTemplateRows:`repeat(24,${size}px)`, imageRendering:"pixelated" }}>
      {grid.flat().map((color, i) => (
        <div key={i} style={{ width:size, height:size, background:color||"transparent" }} />
      ))}
    </div>
  );
}

// ─── Feature pill ─────────────────────────────────────────────────────────────

function FeaturePill({ icon, text }) {
  return (
    <div style={{ display:"flex", alignItems:"center", gap:7, background:"rgba(192,132,252,0.18)", border:"1px solid rgba(192,132,252,0.45)", borderRadius:99, padding:"6px 13px" }}>
      <span style={{ fontSize:15 }}>{icon}</span>
      <span style={{ fontSize:13, color:"#f0e6ff", fontWeight:600 }}>{text}</span>
    </div>
  );
}

// ─── Shared input style ───────────────────────────────────────────────────────

const inp = {
  width:"100%", background:"rgba(255,255,255,0.06)",
  border:"1px solid rgba(255,255,255,0.15)",
  borderRadius:10, color:"#f0e6ff",
  padding:"11px 14px", fontSize:16,
  outline:"none", fontFamily:"inherit",
  boxSizing:"border-box",
};

// ─── Auth card (reutilizable en mobile y desktop) ────────────────────────────

function AuthCard({ showForm, setShowForm, mode, setMode, email, setEmail, password, setPassword, error, clearError, loading, handleGoogle, handleEmail }) {
  return (
    <div style={{
      background:"rgba(255,255,255,0.05)",
      border:"1px solid rgba(255,255,255,0.11)",
      borderRadius:20, padding:"24px 22px",
      width:"100%", boxSizing:"border-box",
    }}>
      <div style={{ fontSize:15, fontWeight:700, color:"#e9d5ff", marginBottom:16, textAlign:"center" }}>
        {showForm ? (mode === "login" ? "Sign in to your account" : "Create an account") : "Get started — it's free"}
      </div>

      {/* Google */}
      <button onClick={handleGoogle} disabled={loading} style={{
        width:"100%", padding:"13px", borderRadius:10,
        border:"none", background:"#ffffff",
        color:"#1a0835", fontWeight:700, fontSize:16,
        cursor:"pointer", display:"flex", alignItems:"center",
        justifyContent:"center", gap:10, marginBottom:10,
        fontFamily:"inherit", boxSizing:"border-box",
      }}>
        <svg width="18" height="18" viewBox="0 0 48 48">
          <path fill="#FFC107" d="M43.6 20H24v8h11.3C33.6 33.1 29.3 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3 0 5.8 1.1 7.9 3l5.7-5.7C34.1 6.5 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20c11 0 19.7-8 19.7-20 0-1.3-.1-2.7-.1-4z"/>
          <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.5 15.1 18.9 12 24 12c3 0 5.8 1.1 7.9 3l5.7-5.7C34.1 6.5 29.3 4 24 4 16.3 4 9.7 8.3 6.3 14.7z"/>
          <path fill="#4CAF50" d="M24 44c5.2 0 9.9-1.9 13.5-5.1l-6.3-5.2C29.3 35.3 26.8 36 24 36c-5.2 0-9.6-3.3-11.3-8H6.1v5.5C9.5 39.8 16.3 44 24 44z"/>
          <path fill="#1976D2" d="M43.6 20H24v8h11.3c-.9 2.5-2.6 4.6-4.9 6l6.3 5.2C40.5 36 44 30.5 44 24c0-1.3-.1-2.7-.4-4z"/>
        </svg>
        Continue with Google
      </button>

      {/* Email toggle / form */}
      {!showForm ? (
        <button onClick={() => setShowForm(true)} style={{
          width:"100%", padding:"12px", borderRadius:10,
          border:"none", background:"#7c3aed", color:"#ffffff",
          fontWeight:700, fontSize:15, cursor:"pointer", fontFamily:"inherit",
          boxSizing:"border-box",
        }}>
          Sign in with email
        </button>
      ) : (
        <>
          <div style={{ display:"flex", alignItems:"center", gap:8, margin:"4px 0 12px" }}>
            <div style={{ flex:1, height:1, background:"rgba(255,255,255,0.09)" }}/>
            <span style={{ fontSize:12, color:"#6b4fa0" }}>or</span>
            <div style={{ flex:1, height:1, background:"rgba(255,255,255,0.09)" }}/>
          </div>
          <form onSubmit={handleEmail} style={{ display:"flex", flexDirection:"column", gap:10 }}>
            <input type="email" placeholder="Email" value={email}
              onChange={e => { setEmail(e.target.value); clearError(); }}
              style={inp} autoComplete="email" />
            <input type="password" placeholder="Password" value={password}
              onChange={e => { setPassword(e.target.value); clearError(); }}
              style={inp} autoComplete={mode === "register" ? "new-password" : "current-password"} />
            {error && (
              <div style={{ background:"rgba(220,38,38,0.15)", border:"1px solid rgba(220,38,38,0.3)", borderRadius:8, padding:"9px 12px", color:"#fca5a5", fontSize:14 }}>
                {error}
              </div>
            )}
            <button type="submit" disabled={loading} style={{
              width:"100%", padding:"13px", borderRadius:10,
              border:"none", background:"#7c3aed",
              color:"#fff", fontWeight:700, fontSize:16,
              cursor:"pointer", fontFamily:"inherit", marginTop:2,
            }}>
              {loading ? "..." : mode === "login" ? "Sign in" : "Create account"}
            </button>
          </form>
          <div style={{ textAlign:"center", marginTop:14, fontSize:14, color:"#6b4fa0" }}>
            {mode === "login" ? (
              <>Don't have an account?{" "}
                <button onClick={() => { setMode("register"); clearError(); }}
                  style={{ background:"none", border:"none", color:"#a78bfa", fontWeight:700, cursor:"pointer", fontSize:14, fontFamily:"inherit" }}>
                  Sign up
                </button>
              </>
            ) : (
              <>Already have an account?{" "}
                <button onClick={() => { setMode("login"); clearError(); }}
                  style={{ background:"none", border:"none", color:"#a78bfa", fontWeight:700, cursor:"pointer", fontSize:14, fontFamily:"inherit" }}>
                  Sign in
                </button>
              </>
            )}
          </div>
        </>
      )}
    </div>
  );
}

// ─── Main component ───────────────────────────────────────────────────────────

export default function AuthModal() {
  const [mode,     setMode]     = useState("login");
  const [email,    setEmail]    = useState("");
  const [password, setPassword] = useState("");
  const [error,    setError]    = useState("");
  const [loading,  setLoading]  = useState(false);
  const [showForm, setShowForm] = useState(false);

  const clearError = () => setError("");

  async function handleGoogle() {
    setLoading(true); clearError();
    try { await signInWithPopup(auth, googleProvider); }
    catch (e) { setError(friendlyError(e.code)); }
    finally { setLoading(false); }
  }

  async function handleEmail(e) {
    e.preventDefault();
    if (!email || !password) { setError("Please fill in all fields."); return; }
    setLoading(true); clearError();
    try {
      if (mode === "register") await createUserWithEmailAndPassword(auth, email, password);
      else                     await signInWithEmailAndPassword(auth, email, password);
    } catch (err) { setError(friendlyError(err.code)); }
    finally { setLoading(false); }
  }

  return (
    <div style={{
      position:"fixed", inset:0,
      background:"linear-gradient(160deg,#0f0520 0%,#1a0835 55%,#0a0218 100%)",
      fontFamily:"'DM Sans',sans-serif",
      color:"#f0e6ff",
      overflowY:"auto",
    }}>
      <style>{`
        .auth-outer {
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 40px 20px 56px;
          min-height: 100%;
          box-sizing: border-box;
        }
        .auth-left {
          width: 100%;
          max-width: 440px;
          text-align: center;
          order: 1;
        }
        .auth-right {
          width: 100%;
          max-width: 400px;
          order: 2;
        }
        @media (min-width: 768px) {
          .auth-outer {
            flex-direction: row;
            align-items: flex-start;
            justify-content: center;
            gap: 48px;
            padding: 60px 40px;
          }
          .auth-left {
            flex: 6;
            max-width: 580px;
            order: 1;
          }
          .auth-right {
            flex: 4;
            max-width: 400px;
            order: 2;
            position: sticky;
            top: 60px;
          }
        }
      `}</style>

      <div className="auth-outer">

        {/* ── Columna izquierda: logo + preview + (mobile: auth primero) ── */}
        <div className="auth-left">
          <div style={{ display:"flex", justifyContent:"center", marginBottom:14 }}>
            <MochiLogo size={5} />
          </div>
          <div style={{ fontSize:30, fontWeight:800, letterSpacing:3, fontFamily:"'JetBrains Mono',monospace", color:"#f0e6ff", marginBottom:4 }}>
            MOCHI
          </div>
          <div style={{ fontSize:12, fontWeight:700, letterSpacing:3, color:"#a78bfa", textTransform:"uppercase", marginBottom:14 }}>
            Call Tracker for Freelance Interpreters
          </div>
          <p style={{ fontSize:15, color:"#c4a8e8", lineHeight:1.75, marginBottom:16, padding:"0 4px" }}>
            It's hard to stay motivated when you can't see your progress. Mochi tracks more than money.
          </p>

          {/* Auth card — solo visible en mobile, aquí arriba */}
          <div className="auth-mobile-only">
            <style>{`.auth-mobile-only { display: block; } @media (min-width: 768px) { .auth-mobile-only { display: none; } }`}</style>
            <AuthCard
              showForm={showForm} setShowForm={setShowForm}
              mode={mode} setMode={setMode}
              email={email} setEmail={setEmail}
              password={password} setPassword={setPassword}
              error={error} clearError={clearError}
              loading={loading}
              handleGoogle={handleGoogle} handleEmail={handleEmail}
            />
            <div style={{ marginBottom:24 }} />
          </div>

          {/* App preview */}
          <div style={{ fontSize:12, fontStyle:"italic", color:"#c4a8e8", marginBottom:8 }}>
            Is Mochi real? It is! And it looks like this:
          </div>
          <div style={{
            background:"#1a0f35", border:"1px solid rgba(167,139,250,0.25)",
            borderRadius:14, overflow:"hidden", marginBottom:18, textAlign:"left",
          }}>
            {/* Topbar */}
            <div style={{ background:"#130929", borderBottom:"1px solid rgba(255,255,255,0.07)", padding:"7px 12px", display:"flex", alignItems:"center", justifyContent:"space-between" }}>
              <div style={{ display:"flex", alignItems:"center", gap:7 }}>
                <MochiLogo size={2} />
                <div>
                  <div style={{ fontSize:10, fontWeight:800, letterSpacing:2, fontFamily:"'JetBrains Mono',monospace", color:"#f0e6ff" }}>MOCHI</div>
                  <div style={{ fontSize:8, color:"#6b4fa0", letterSpacing:1 }}>03/31/2026</div>
                </div>
              </div>
              <div style={{ background:"rgba(167,139,250,0.15)", border:"1px solid rgba(167,139,250,0.3)", borderRadius:7, padding:"2px 8px", fontSize:9, color:"#a78bfa", fontWeight:700 }}>🎯 Goal</div>
            </div>
            {/* Body */}
            <div style={{ padding:"10px 12px" }}>
              <div style={{ background:"rgba(255,255,255,0.04)", border:"1px solid rgba(255,255,255,0.08)", borderRadius:10, padding:"9px 11px 7px", marginBottom:7 }}>
                <div style={{ fontSize:8, fontWeight:700, letterSpacing:2, color:"#6b4fa0", textTransform:"uppercase", marginBottom:1 }}>Earnings Today</div>
                <div style={{ fontSize:22, fontWeight:800, color:"#86d96b", fontFamily:"'JetBrains Mono',monospace", lineHeight:1, marginBottom:2 }}>$18.12</div>
                <div style={{ fontSize:9, color:"#9d78d8", marginBottom:5 }}>8 calls · 151m done · 16m remaining</div>
                <div style={{ background:"rgba(255,255,255,0.07)", borderRadius:3, height:4, marginBottom:3 }}>
                  <div style={{ width:"72%", height:4, borderRadius:3, background:"linear-gradient(90deg,#7c3aed,#c084fc)" }} />
                </div>
                <div style={{ display:"flex", justifyContent:"space-between", fontSize:8, color:"#6b4fa0" }}>
                  <span>$0</span><span style={{ color:"#c084fc", fontWeight:700 }}>72% · $25 goal</span><span>$25</span>
                </div>
                <div style={{ display:"flex", gap:3, marginTop:5 }}>
                  {["#c084fc","#c084fc","#c084fc"].map((c,i) => <div key={i} style={{ flex:1, height:3, borderRadius:2, background:c }} />)}
                  <div style={{ flex:1, height:3, borderRadius:2, background:"rgba(192,132,252,0.3)", border:"1px solid rgba(192,132,252,0.5)" }} />
                  <div style={{ flex:1, height:3, borderRadius:2, background:"rgba(255,255,255,0.06)" }} />
                </div>
              </div>
              <div style={{ display:"flex", gap:6, marginBottom:7, alignItems:"center" }}>
                <div style={{ background:"rgba(255,184,0,0.12)", border:"1px solid rgba(255,184,0,0.3)", borderRadius:7, padding:"3px 8px", fontSize:9, fontWeight:700, color:"#ffb800" }}>🥇 Gold surge · $0.15/min</div>
                <div style={{ flex:1, background:"rgba(255,255,255,0.03)", border:"1px solid rgba(255,255,255,0.06)", borderRadius:7, padding:"3px 10px", display:"flex", justifyContent:"space-between" }}>
                  <span style={{ fontSize:8, fontWeight:700, letterSpacing:1, color:"#6b4fa0" }}>IDLE</span>
                  <span style={{ fontSize:9, fontWeight:700, color:"#f87171", fontFamily:"'JetBrains Mono',monospace" }}>-$0.79</span>
                </div>
              </div>
              <div style={{ display:"flex", justifyContent:"space-between", marginBottom:5 }}>
                <span style={{ fontSize:9, fontWeight:700, color:"#c4a8e8" }}>Today's calls</span>
                <span style={{ fontSize:9, color:"#6b4fa0" }}>8</span>
              </div>
              {[
                { tier:"#ffb800", time:"4:12p", dur:"23m", pay:"+$3.45", op:1 },
                { tier:"#8fa8c2", time:"3:44p", dur:"18m", pay:"+$2.52", op:1 },
                { tier:"#c47d3a", time:"2:58p", dur:"31m", pay:"+$4.03", op:1 },
                { tier:"#7a8a9a", time:"1:20p", dur:"12m", pay:"+$1.44", op:0.4 },
              ].map((r,i) => (
                <div key={i} style={{ display:"flex", alignItems:"center", justifyContent:"space-between", padding:"4px 0", borderBottom: i<3 ? "1px solid rgba(255,255,255,0.05)" : "none", opacity:r.op }}>
                  <div style={{ display:"flex", alignItems:"center", gap:6 }}>
                    <div style={{ width:6, height:6, borderRadius:"50%", background:r.tier }} />
                    <span style={{ fontSize:9, color:"#9d78d8" }}>{r.time}</span>
                  </div>
                  <span style={{ fontSize:9, color:"#c4a8e8", fontWeight:600 }}>{r.dur}</span>
                  <span style={{ fontSize:9, color:"#86d96b", fontWeight:700, fontFamily:"'JetBrains Mono',monospace" }}>{r.pay}</span>
                </div>
              ))}
              <div style={{ marginTop:8 }}>
                <div style={{ fontSize:8, fontWeight:700, letterSpacing:2, color:"#6b4fa0", textTransform:"uppercase", marginBottom:4 }}>Hourly activity</div>
                <div style={{ display:"flex", gap:2 }}>
                  {[0.07,0.07,0.07,0.1,0.07,0.07,0.07,0.07,0.07,0.2,0.35,0.45,0.3,0.15,0.55,0.75,0.9,0.7,0.5,0.2,0.12,0.07,0.07,0.07].map((o,i) => (
                    <div key={i} style={{ flex:1, height:12, borderRadius:2, background: o > 0.4 ? `rgba(192,132,252,${o})` : `rgba(124,58,237,${o})` }} />
                  ))}
                </div>
                <div style={{ display:"flex", justifyContent:"space-between", marginTop:2 }}>
                  {["12a","6a","12p","3p","6p","9p"].map(t => <span key={t} style={{ fontSize:7, color:"#4a3070" }}>{t}</span>)}
                </div>
              </div>
              <div style={{ background:"rgba(255,255,255,0.04)", border:"1px solid rgba(255,255,255,0.08)", borderRadius:9, padding:"7px 11px", marginTop:7 }}>
                <div style={{ fontSize:8, fontWeight:700, letterSpacing:2, color:"#6b4fa0", textTransform:"uppercase", marginBottom:1 }}>Cycle projection</div>
                <div style={{ fontSize:16, fontWeight:800, color:"#ffb800", fontFamily:"'JetBrains Mono',monospace" }}>$163.61</div>
                <div style={{ fontSize:8, color:"#6b4fa0", marginTop:1 }}>At this rate · Day 11/14 · 3d remaining</div>
                <div style={{ background:"rgba(255,255,255,0.07)", borderRadius:3, height:3, marginTop:5 }}>
                  <div style={{ width:"78%", height:3, borderRadius:3, background:"linear-gradient(90deg,#7c3aed,#86d96b)" }} />
                </div>
              </div>
            </div>
            <div style={{ display:"flex", justifyContent:"space-around", background:"#130929", borderTop:"1px solid rgba(255,255,255,0.07)", padding:"5px 0 4px" }}>
              {[["☀️","Today",true],["⚡","Stats",false],["📅","Week",false],["🔄","Cycle",false],["📋","History",false]].map(([icon,label,active]) => (
                <div key={label} style={{ display:"flex", flexDirection:"column", alignItems:"center", gap:2 }}>
                  <span style={{ fontSize:12 }}>{icon}</span>
                  <span style={{ fontSize:7, color: active ? "#c084fc" : "#6b4fa0" }}>{label}</span>
                  {active && <div style={{ width:3, height:3, borderRadius:"50%", background:"#c084fc" }} />}
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* ── Columna derecha: auth + pills + badges ── */}
        <div className="auth-right">
          {/* Auth card — solo visible en desktop */}
          <div className="auth-desktop-only">
            <style>{`.auth-desktop-only { display: none; } @media (min-width: 768px) { .auth-desktop-only { display: block; } }`}</style>
            <AuthCard
              showForm={showForm} setShowForm={setShowForm}
              mode={mode} setMode={setMode}
              email={email} setEmail={setEmail}
              password={password} setPassword={setPassword}
              error={error} clearError={clearError}
              loading={loading}
              handleGoogle={handleGoogle} handleEmail={handleEmail}
            />
            <div style={{ marginBottom:20 }} />
          </div>

          {/* Pills */}
          <div style={{ display:"flex", flexWrap:"wrap", gap:7, justifyContent:"center", marginBottom:16 }}>
            <FeaturePill icon="⚡" text="Surge detection" />
            <FeaturePill icon="🔄" text="Pay cycle tracking" />
            <FeaturePill icon="☀️" text="Daily goal" />
            <FeaturePill icon="📊" text="Hourly heatmap" />
            <FeaturePill icon="📋" text="Paste from Propio" />
          </div>

          {/* Cloud badge */}
          <div style={{
            display:"flex", alignItems:"center", gap:10,
            background:"rgba(167,139,250,0.1)",
            border:"1px solid rgba(167,139,250,0.28)",
            borderRadius:12, padding:"11px 16px", marginBottom:10,
            textAlign:"left",
          }}>
            <span style={{ fontSize:22 }}>☁️</span>
            <div>
              <div style={{ fontSize:14, fontWeight:700, color:"#e9d5ff" }}>Your data, on every device</div>
              <div style={{ fontSize:12, color:"#9d78d8", marginTop:2 }}>
                Sign in once — calls and settings sync everywhere automatically
              </div>
            </div>
          </div>

          {/* Free forever badge */}
          <div style={{
            display:"flex", alignItems:"center", justifyContent:"center", gap:8,
            background:"rgba(167,139,250,0.1)",
            border:"1px solid rgba(167,139,250,0.45)",
            borderRadius:10, padding:"10px 16px",
            fontSize:13, fontWeight:700, color:"#e9d5ff",
          }}>
            ✨ Free forever · No subscriptions · No ads
          </div>
        </div>

      </div>
    </div>
  );
}

// ─── Error messages ───────────────────────────────────────────────────────────

function friendlyError(code) {
  switch (code) {
    case "auth/invalid-email":        return "Invalid email address.";
    case "auth/user-not-found":       return "No account found with this email.";
    case "auth/wrong-password":       return "Incorrect password.";
    case "auth/email-already-in-use": return "This email is already registered.";
    case "auth/weak-password":        return "Password must be at least 6 characters.";
    case "auth/too-many-requests":    return "Too many attempts. Try again later.";
    case "auth/popup-closed-by-user": return "Google sign-in was cancelled.";
    case "auth/invalid-credential":   return "Incorrect email or password.";
    default:                          return "Something went wrong. Please try again.";
  }
}
